import script from "./ChartsDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChartsDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChartsDeleteModal.vue?vue&type=style&index=0&id=17525cd4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17525cd4"]])

export default __exports__